import React from "react";
import Layout from "../Layout";

const Dashboard = () => {
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "80vh",
      textAlign: "center",
      background: "linear-gradient(135deg, #f0f4ff, #e6ecff)",
      borderRadius: "16px",
      boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
      color: "#1e293b",
      padding: "20px",
      animation: "fadeIn 1s ease-in-out",
    },
    title: {
      fontSize: "2.5rem",
      fontWeight: "700",
      marginBottom: "10px",
      background: "linear-gradient(90deg, #d7182a, #2563eb)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    subtitle: {
      fontSize: "1.1rem",
      color: "#475569",
    },
    // Keyframe animation (inline workaround)
    "@keyframes fadeIn": {
      from: { opacity: 0, transform: "translateY(20px)" },
      to: { opacity: 1, transform: "translateY(0)" },
    },
  };

  return (
    <Layout type={"read_per"} module_data={"dashboard"}>
      <div style={styles.container}>
        <h1 style={styles.title}>Welcome to CMS</h1>
        <p style={styles.subtitle}>
          Manage content and configurations with ease.
        </p>
      </div>
    </Layout>
  );
};

export default Dashboard;
